import React from 'react'
import ReactDOM from 'react-dom/client'
import './app/globals.css'
import App from './App'

const BACKEND = process.env.REACT_APP_BACKEND_URL || ''
const nativeFetch = window.fetch.bind(window)
window.fetch = (input, init) => {
  if (typeof input === 'string' && input.startsWith('/api')) input = BACKEND + input
  return nativeFetch(input, { credentials: 'include', ...(init || {}) })
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
